import { resourceExplorerChartBaseSelector } from "../../resourceExplorerChartBaseSelector";
import { resourceExplorerIdSelector } from "../resourceExplorerIdSelector";
import { RootState } from "@/store/store";
import { resourceExplorerChartSettingsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/resourceExplorerChartSettingsSelector";

export const resourceExplorerShowBudgetLineSelector = (state: RootState) => {
  const data = resourceExplorerChartSettingsSelector(state);
  const viewId = resourceExplorerIdSelector(state);
  const chartBase = resourceExplorerChartBaseSelector(state);

  return data?.show_budget_line && chartBase !== "percent" && viewId;
};
